import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

import FilterTitle from './FilterTitle'

const StyledWrapper = styled.div`
  border-bottom: 1px solid ${colors.secondary70};
`

const FilterSectionBool = ({ value, title, name, onChange, disabled }) => {
  const onValueChange = (val) => {
    if (!onChange) {
      return
    }

    const result = {
      value: val,
      name: name,
      type: 'bool',
    }

    onChange(result)
  }

  return (
    <StyledWrapper>
      <FilterTitle
        active={value}
        title={title}
        onActiveChange={onValueChange}
        disabled={disabled}
      />
    </StyledWrapper>
  )
}

FilterSectionBool.propTypes = {
  value: PropTypes.bool,
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

export default FilterSectionBool
